export function BotLogo({ size = 48, className, style }) {
  const s = size;
  const cx = s / 2;
  const cy = s / 2;
  const r = s * 0.46;
  const top = { x: cx, y: cy - r * 0.72 };
  const left = { x: cx - r * 0.78, y: cy + r * 0.52 };
  const right = { x: cx + r * 0.78, y: cy + r * 0.52 };
  const iTop = { x: cx, y: cy + r * 0.30 };
  const iLeft = { x: cx - r * 0.34, y: cy - r * 0.08 };
  const iRight = { x: cx + r * 0.34, y: cy - r * 0.08 };

  return (
    <svg width={s} height={s} viewBox={`0 0 ${s} ${s}`} fill="none" xmlns="http://www.w3.org/2000/svg" className={className} style={style}>
      <defs>
        <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#ffc846" stopOpacity="1" />
          <stop offset="50%" stopColor="#ffa028" stopOpacity="1" />
          <stop offset="100%" stopColor="#c87814" stopOpacity="1" />
        </linearGradient>
        <linearGradient id="bloodGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#a01020" stopOpacity="1" />
          <stop offset="100%" stopColor="#4a0008" stopOpacity="1" />
        </linearGradient>
        <filter id="glow" x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur stdDeviation={s * 0.04} result="blur" />
          <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
        </filter>
        <filter id="glowGold" x="-30%" y="-30%" width="160%" height="160%">
          <feGaussianBlur stdDeviation={s * 0.03} result="blur" />
          <feMerge><feMergeNode in="blur" /><feMergeNode in="SourceGraphic" /></feMerge>
        </filter>
      </defs>
      <circle cx={cx} cy={cy} r={r * 0.98} stroke="url(#goldGrad)" strokeWidth={s * 0.018} opacity="0.55" />
      {[0, 60, 120, 180, 240, 300].map((deg, i) => {
        const rad = (deg * Math.PI) / 180;
        const x1 = cx + r * 0.98 * Math.cos(rad);
        const y1 = cy + r * 0.98 * Math.sin(rad);
        const rad2 = ((deg + 40) * Math.PI) / 180;
        const x2 = cx + r * 0.98 * Math.cos(rad2);
        const y2 = cy + r * 0.98 * Math.sin(rad2);
        return (
          <path key={i}
            d={`M ${x1} ${y1} A ${r * 0.98} ${r * 0.98} 0 0 1 ${x2} ${y2}`}
            stroke={i % 2 === 0 ? "#ffa028" : "#6b0015"}
            strokeWidth={s * 0.028}
            opacity={i % 2 === 0 ? 0.8 : 0.6}
            strokeLinecap="round"
            filter="url(#glow)"
          />
        );
      })}
      <circle cx={cx} cy={cy} r={r * 0.78} stroke="url(#bloodGrad)" strokeWidth={s * 0.015} opacity="0.6"
        strokeDasharray={`${s * 0.07} ${s * 0.04}`} />
      <polygon
        points={`${top.x},${top.y} ${left.x},${left.y} ${right.x},${right.y}`}
        fill="rgba(6,4,12,0.88)" stroke="url(#goldGrad)" strokeWidth={s * 0.025}
        strokeLinejoin="round" filter="url(#glowGold)"
      />
      <polygon
        points={`${iTop.x},${iTop.y} ${iLeft.x},${iLeft.y} ${iRight.x},${iRight.y}`}
        fill="none" stroke="#6b0015" strokeWidth={s * 0.016}
        strokeLinejoin="round" opacity="0.85" filter="url(#glow)"
      />
      <ellipse cx={cx} cy={cy - r * 0.04} rx={r * 0.22} ry={r * 0.13}
        fill="none" stroke="#ffa028" strokeWidth={s * 0.014} opacity="0.9" />
      <circle cx={cx} cy={cy - r * 0.04} r={r * 0.08} fill="url(#bloodGrad)" opacity="0.95" />
      <circle cx={cx} cy={cy - r * 0.04} r={r * 0.035} fill="#06040c" />
      <circle cx={cx + r * 0.02} cy={cy - r * 0.07} r={r * 0.015} fill="#ffc846" opacity="0.8" />
      <text x={cx} y={cy + r * 0.40} textAnchor="middle" fontFamily="'Cinzel', serif"
        fontSize={s * 0.16} fill="url(#goldGrad)" opacity="0.9" letterSpacing="0.05em" filter="url(#glowGold)">
        DELTA
      </text>
      <line x1={top.x - s * 0.05} y1={top.y + s * 0.02} x2={top.x + s * 0.05} y2={top.y + s * 0.02}
        stroke="#ffa028" strokeWidth={s * 0.012} opacity="0.6" strokeLinecap="round" />
      <line x1={left.x + s * 0.06} y1={left.y - s * 0.01} x2={left.x + s * 0.10} y2={left.y - s * 0.035}
        stroke="#6b0015" strokeWidth={s * 0.012} opacity="0.65" strokeLinecap="round" />
      <line x1={right.x - s * 0.06} y1={right.y - s * 0.01} x2={right.x - s * 0.10} y2={right.y - s * 0.035}
        stroke="#6b0015" strokeWidth={s * 0.012} opacity="0.65" strokeLinecap="round" />
      <circle cx={top.x} cy={top.y} r={s * 0.018} fill="#ffa028" opacity="0.9" filter="url(#glowGold)" />
      <circle cx={left.x} cy={left.y} r={s * 0.018} fill="#6b0015" opacity="0.9" filter="url(#glow)" />
      <circle cx={right.x} cy={right.y} r={s * 0.018} fill="#6b0015" opacity="0.9" filter="url(#glow)" />
    </svg>
  );
}
